import * as v from 'valibot';

import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';
import { betterParse } from '@/lib/schema-utils.ts';

import type { Route } from './+types/LandingPage';
import { CompetitionsSection } from './_sections/CompetitionsSection.tsx';
import { TimerSection } from './_sections/TimerSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';

const MetaSchema = v.nullish(
  v.object({
    displayWarningWhenKIn: v.array(v.union([v.pipe(v.number(), v.toString()), v.string()])),
  }),
  () => undefined,
);

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const activeCompetition = await getActiveCompetition(competitions);
  const currentCompetition = competitions.find((c) => c.slug === 'april_2026_campaign');
  const allWinners = competitions.flatMap((d) => d.winners);
  const index = competitions.findIndex((c) => c.slug === 'april_2026_campaign');
  const previousCompetitions = competitions.slice(index + 1);

  const meta = betterParse(MetaSchema, currentCompetition?.meta).unwrap();

  return {
    activeCompetition,
    winners: currentCompetition?.winners,
    allWinners,
    previousCompetitions,
    displayWarningWhenKIn: meta?.displayWarningWhenKIn,
  };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Gjett om du kan få lavere rente med Scoopr">
      <div className="w-full bg-white">
        <TopSection
          activeCompetition={loaderData.activeCompetition}
          winners={loaderData.winners}
          allWinners={loaderData.allWinners}
          displayWarningWhenKIn={loaderData.displayWarningWhenKIn}
        />
        <TimerSection
          activeCompetition={loaderData.activeCompetition}
          displayWarningWhenKIn={loaderData.displayWarningWhenKIn}
        />
        <CompetitionsSection competitions={loaderData.previousCompetitions} />
      </div>
    </Page>
  );
}
